import React from "react"
import {
    componentStyles,
    MultiMediaDisplay,
    MediaDisplayType,
    UploadCareImageVariant,
} from "@mallardbay/lib-react-components"

import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import type { ListingFieldsFragment } from "~graphql/generated/graphql"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly listing: ListingFieldsFragment
}

export default function WidgetListingImages({ listing }: Props) {
    const styles = useStyles()
    const { isLargerThanTablet } = useTabletMediaQueries()

    const displayType = isLargerThanTablet
        ? MediaDisplayType.GRID_COMPACT
        : MediaDisplayType.CAROUSEL

    return (
        <Box style={styles.root}>
            <MultiMediaDisplay
                images={listing.photos}
                type={displayType}
                imageVariant={UploadCareImageVariant.LG_HORIZONTAL}
                imageWidth={1200}
            />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            overflow: "hidden",
            borderRadius: "xl",
        },
    })
}
